import { useEffect } from 'react';
import {
  useShiftRotationAddEditStore,
  useShiftSeriesAddEditStore,
  useShiftAddEditStore,
  useRotationsListStore,
  usePublishDrawerStore,
  useShareDrawerStore,
  useShiftSeriesEditStore,
  useRotationSeriesEditStore,
} from '@libs/store/shifts';
import { useOrgQualificationsStore } from '@libs/store/settings';
import { useRefreshSyncStore } from '@libs/store/refreshSync';
import { useLocationStore } from '@libs/store/locations';
import { useTalentsStore } from '@libs/store/talents';
import { PrimaryPaper } from '@atoms/layout';
import { PublishShiftsDrawer, EditRotationDrawer, EditSeriesDrawer, EditShiftDrawer, ShareShifts } from '../../drawers';
import { SeriesNRotationsTable } from './table';
import { RotationDetailsDrawer, SeriesDetailsDrawer } from '@pages/schedule/drawers/shiftDetails';
import { ShiftTableMenu } from '../shiftTableMenu';
import { Box, Stack } from '@mui/material';
import { RecurrencesFilters } from './filters';

export function RotationsListPage() {
  const { initiated: talentsListInitiated, load } = useTalentsStore();
  const { initiated: qualListInitiated } = useOrgQualificationsStore();
  const { currentInitiated: currentLocationInitiated, currentLocationID } = useLocationStore();
  const { initiated: rotationsListInitiated } = useRotationsListStore();

  const loading = !rotationsListInitiated || !qualListInitiated || !currentLocationInitiated || !talentsListInitiated;

  useEffect(() => {
    if (!currentLocationID) {
      // Location is required for talents list, waiting till location is loaded
      return;
    }
    load({
      filters: {
        locations: { key: 'locations', value: [currentLocationID] },
      },
      page: 1,
      size: 20,
    });
  }, [load, currentLocationID]);

  return (
    <>
      <ShiftTableMenu loading={loading} />
      <PrimaryPaper sx={{ height: '100%', minHeight: 0, mt: 2 }}>
        <Stack direction="column" height="100%">
          <RecurrencesFilters loading={loading} />
          <Box mt={2} height="100%" minHeight={0}>
            <SeriesNRotationsTable />
          </Box>
        </Stack>
      </PrimaryPaper>
      <Drawers />
    </>
  );
}

function Drawers() {
  const { callRefresh } = useRefreshSyncStore();
  const { drawerOpen: seriesDrawerOpen } = useShiftSeriesAddEditStore();
  const { drawerOpen: rotationDrawerOpen } = useShiftRotationAddEditStore();
  const { drawerOpen: shiftEditDrawerOpen } = useShiftAddEditStore();
  const { drawerOpen: shareDrawerOpen } = useShareDrawerStore();
  const { drawerOpen: publishDrawerOpen } = usePublishDrawerStore();
  const { drawerOpen: seriesDetailsDrawerOpen } = useShiftSeriesEditStore();
  const { drawerOpen: rotationDetailsDrawerOpen } = useRotationSeriesEditStore();

  const handleListPossiblyChanged = () => {
    callRefresh();
  };

  return (
    <>
      {seriesDetailsDrawerOpen && <SeriesDetailsDrawer onSaved={handleListPossiblyChanged} />}
      {rotationDetailsDrawerOpen && <RotationDetailsDrawer onSaved={handleListPossiblyChanged} />}
      {shiftEditDrawerOpen && <EditShiftDrawer onSaveCall={handleListPossiblyChanged} />}
      {seriesDrawerOpen && <EditSeriesDrawer onSaveCall={handleListPossiblyChanged} />}
      {rotationDrawerOpen && <EditRotationDrawer onSaveCall={handleListPossiblyChanged} />}
      {publishDrawerOpen && <PublishShiftsDrawer onSaveCall={handleListPossiblyChanged} />}
      {shareDrawerOpen && <ShareShifts onSaveCall={handleListPossiblyChanged} />}
    </>
  );
}
